import { useState, useEffect } from "react";
import Switch from "components/BaseWidgets/switch";
import "./style.scss";
import CardLayout from "components/Settings/components/CardLayout";
import { NotificationLabels } from "../../helper";

function ManageCard({ data, onChange }) {
  const [toggles, setToggles] = useState(
    data.map((item) => ({
      notification_type: item.notification_type,
      push: item.push === 1,
      sms: item.sms === 1,
      email: item.email === 1,
    })),
  );

  useEffect(() => {
    onChange && onChange(toggles);
  }, [toggles]);

  const handleToggle = (id, type, value) => {
    setToggles((prev) =>
      prev.map((row) =>
        row.notification_type === id ? { ...row, [type]: value } : row,
      ),
    );
  };

  return (
    <CardLayout className="notification-manage-card">
      <div className="header-row">
        <div className="empty-cell" />
        <div className="toggle-label">Push</div>
        <div className="toggle-label">Whatsapp</div>
        <div className="toggle-label">Email</div>
      </div>

      {toggles.map((item) => (
        <div className="toggle-row" key={item.id}>
          <div className="label">
            {NotificationLabels[item.notification_type]}
          </div>
          <Switch
            isChecked={item.push}
            onChange={(checked) =>
              handleToggle(item.notification_type, "push", checked)
            }
          />
          <Switch
            isChecked={item.sms}
            onChange={(checked) =>
              handleToggle(item.notification_type, "sms", checked)
            }
          />
          <Switch
            isChecked={item.email}
            onChange={(checked) =>
              handleToggle(item.notification_type, "email", checked)
            }
          />
        </div>
      ))}
    </CardLayout>
  );
}

export default ManageCard;
